<div class="dialog"
  fxLayout="column"
  fxLayoutAlign="center center">

  <div class="dialog-content"
    fxLayout="column"
    fxLayoutGap="10px">

    <div>
      <h2 [innerHTML]="title"
        style="color: white;"></h2>

      <p [innerHTML]="text"
        style="color: white; text-align: left;"></p>

      <textarea [(ngModel)]="message"
        style="width: 100%; padding: 10px 10px;text-indent: 0px; box-sizing: border-box;"
        class="zimTextarea"
        autoresize
        rows="5"></textarea>
    </div>

    <!-- buttonrow -->
    <div fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="end center">
      <button (click)="cancel()">Abbrechen</button>
      <button (click)="send()"
        class="orange-button">
        Senden
      </button>
    </div>

  </div>

</div>